import { render } from "./info-about-company-name-and-department.vue?vue&type=template&id=523eab82&scoped=true&ts=true"
import script from "./info-about-company-name-and-department.vue?vue&type=script&lang=ts"
export * from "./info-about-company-name-and-department.vue?vue&type=script&lang=ts"

import "./info-about-company-name-and-department.vue?vue&type=style&index=0&id=523eab82&scoped=true&lang=css"

import exportComponent from "/application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523eab82"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
